import Get from '../services/Get';
import Post from '../services/Post';
import Put from '../services/Put';
import Delete from '../services/Delete';

import { nexcareVersion } from '../config/serviceConfig';

// Product
const getInitiateProduct = (token) => Get(`/${nexcareVersion}/nexcare/complaint/initiate`, token);
const getListProduct = (page, limit, token) => Get(`/${nexcareVersion}/nexcare/complaint?page=${page}&limit=${limit}`, token);
const postDataProduct = (data, token) => Post(`/${nexcareVersion}/nexcare/complaint`, data, token);
const putDataProduct = (id, data, token) => Put(`/${nexcareVersion}/nexcare/complaint/${id}`, data, token);
const deleteDataProduct = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/complaint/${id}`, data, token);

// Module
const getInitiateModule = (id, token) => Get(`/${nexcareVersion}/nexcare/complaint-category/initiate?filter=complaint_id eq ${id}`, token);
const getListModule = (id, page, limit, token) => Get(`/${nexcareVersion}/nexcare/complaint-category?page=${page}&limit=${limit}&filter=complaint_id eq ${id}`, token);
const postDataModule = (data, token) => Post(`/${nexcareVersion}/nexcare/complaint-category`, data, token);
const putDataModule = (id, data, token) => Put(`/${nexcareVersion}/nexcare/complaint-category/${id}`, data, token);
const deleteDataModule = (id, data, token) => Delete(`/${nexcareVersion}/nexcare/complaint-category/${id}`, data, token);

// Complaint
const getProductList = (token) => Get(`/${nexcareVersion}/nexcare/complaint-sub/complaint?page=1&limit=100`, token);
const getModuleList = (id, token) => Get(`/${nexcareVersion}/nexcare/complaint-sub/complaint-category?page=1&limit=100&filter=complaint_id eq ${id}`, token);
const getInitiateCategoryIssueList = (id, token) => Get(`/${nexcareVersion}/nexcare/complaint-sub/initiate?filter=complaint_category_id eq ${id}`, token);
const getCategoryIssueList = (id, page, token) => Get(`/${nexcareVersion}/nexcare/complaint-sub?page=${page}&limit=100&filter=complaint_category_id eq ${id}`, token);
const getLevelCSList = (token) => Get(`/${nexcareVersion}/nexcare/complaint-sub/remark/cs-level?page=1&limit=100`, token);
const getPriorityList = (token) => Get(`/${nexcareVersion}/nexcare/complaint-sub/remark/priority?page=1&limit=100`, token);
const postCategoryIssue = (data, token) => Post(`/${nexcareVersion}/nexcare/complaint-sub`, data, token);

const API_ISSUE_CATEGORY = {
    getInitiateProduct,
    getListProduct,
    postDataProduct,
    putDataProduct,
    deleteDataProduct,
    getInitiateModule,
    getListModule,
    postDataModule,
    putDataModule,
    deleteDataModule,
    getProductList,
    getModuleList,
    getInitiateCategoryIssueList,
    getCategoryIssueList,
    getLevelCSList,
    getPriorityList,
    postCategoryIssue,
}

export default API_ISSUE_CATEGORY;